import { getCssUnits, getOutOfScreenDistance } from '../../utils';
export { initialFrame } from './common';
const EASING_MAP = {
  soft: 'cubicInOut',
  medium: 'quintInOut',
  hard: 'backOut'
};
export function web(options, dom) {
  const [{
    custom,
    ...glideIn
  }] = style(options);
  prepare(options, dom);
  return [{
    ...glideIn,
    keyframes: [{
      opacity: 'var(--comp-opacity, 1)',
      translate: custom['--motion-translate']
    }, {
      opacity: 'var(--comp-opacity, 1)',
      translate: '0 0'
    }]
  }];
}
export function style(options) {
  const {
    direction = 0,
    distance = {
      value: 100,
      type: 'percentage'
    },
    power,
    startFromOffScreen = false
  } = options.namedEffect;
  const angleInRad = direction * Math.PI / 180;
  const unit = getCssUnits(distance.type);
  const easing = power && EASING_MAP[power] || options.easing || 'quintInOut';
  const {
    x,
    y
  } = getOutOfScreenDistance(direction);
  const translateX = startFromOffScreen ? x : `${Math.sin(angleInRad) * distance.value | 0}${unit}`;
  const translateY = startFromOffScreen ? y : `${Math.cos(angleInRad) * distance.value * -1 | 0}${unit}`;
  return [{
    ...options,
    name: 'glideIn',
    easing,
    custom: {
      '--motion-translate': `${translateX} ${translateY}`
    }
  }];
}
export function prepare(options, dom) {
  const {
    startFromOffScreen = false
  } = options.namedEffect;
  if (dom && startFromOffScreen) {
    let left = 0;
    let top = 0;
    dom.measure(target => {
      if (!target) {
        return;
      }
      const {
        left: targetLeft,
        top: targetTop
      } = target.getBoundingClientRect();
      left = targetLeft;
      top = targetTop;
    });
    dom.mutate(target => {
      target == null || target.style.setProperty('--motion-left', `${left}px`);
      target == null || target.style.setProperty('--motion-top', `${top}px`);
    });
  }
}
//# sourceMappingURL=GlideIn.js.map